import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { SmartLoaderService } from '../../../core/services/smart-loader.service';

@Component({
  selector: 'itpx-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

    private loading: Observable<boolean>;

    constructor( private loadingService: SmartLoaderService ) { }

    ngOnInit() {
        this.loading = this.loadingService.loading().delay(10);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/loader/loader.component.ts